import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import traceLotDownstream from '../api/traceLotDownstream';

/**
 * Downstream trace walk for one root lot, not cached — it drives the
 * quarantine preview. Also returns
 * `invalidate` so mutations that change the graph (e.g. quarantining
 * downstream) can refetch without knowing the query key.
 */
export default function useLotTrace(lotId) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['lotTrace', lotId],
    queryFn: () => traceLotDownstream(lotId),
    enabled: !!lotId,
  });

  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ['lotTrace', lotId] }),
    [queryClient, lotId],
  );

  return { ...query, invalidate };
}
